module.exports = __webpack_public_path__ + "./fonts/Proxima Nova Bold.ttf";